import { memo, ReactNode } from "react";
import ColorContext from "./ColorContext";
import DataNodeContext from "./DataNodeContext";
import FlowDataContext from "./FlowDataContext";
import LayerContext from "./LayerContext";
import TemplateTypeContext from "./TemplateTypeContext";
import ViewPortContext from "./ViewPortContext";
import ZoomContext from "./ZoomContext";
import NodesPositionContext from "./NodesPositionContext";
import NodesWithPositionContext from "./NodesWithPositionContext";
import ModelDetailsContex from "./ModelDetailsContex";

const WorkbenchProviders = ({ children }: { children: ReactNode }) => (
  <TemplateTypeContext>
    <ColorContext>
      <ZoomContext>
        <ViewPortContext>
          <NodesPositionContext>
            <FlowDataContext>
              <NodesWithPositionContext>
                <DataNodeContext>
                  <LayerContext>
                    <ModelDetailsContex>
                    {children}
                    </ModelDetailsContex>
                    </LayerContext>
                </DataNodeContext>
              </NodesWithPositionContext>
            </FlowDataContext>
          </NodesPositionContext>
        </ViewPortContext>
      </ZoomContext>
    </ColorContext>
  </TemplateTypeContext>
);

export default memo(WorkbenchProviders);
